import { useState, useEffect } from "react";
import AuthLayout from "../../containers/auth";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../utils/axiosConfig";
import { Link } from "react-router-dom";
import msg from "../../assets/msg.svg";
import lock from "../../assets/lock.svg";
import eyeOpen from "../../assets/eye-open.svg";
import eyeSlash from "../../assets/eye-slash.svg";
import google from "../../assets/google.svg";
import { FaApple } from "react-icons/fa";

const Signin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSigningIn, setIsSigningIn] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decodedToken = jwtDecode(token);

      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
      } else {
        navigate("/account/home");
      }
    }

    return () => {};
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Email and Password are required");
      return;
    }

    setIsSigningIn(true);
    try {
      const response = await api.post("/auth/login", { email, password });

      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        toast.success(response.data.message);
        window.location.href = "/account/home";
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    } finally {
      setIsSigningIn(false);
    }
  }

  const handleGoogleLogin = (e) => {
    e.preventDefault();
    window.location.href = `https://tweezers-tweezers-api.sliplane.app/api/auth/google`;
  }

  const handleAppleLogin = (e) => {
    e.preventDefault();
    window.location.href = `https://tweezers-tweezers-api.sliplane.app/api/auth/apple`;
  }

  return (
    <AuthLayout filter="grayscale">
      <h2 className="mb-2 text-2xl font-bold text-secondary text-center">
        Stay Ahead of the Game!
      </h2>
      <p className="mb-6 text-sm text-gray-600 text-center">
        Only login via {" "}
        <span className="font-bold text-secondary">
          Email, Google, or Phone number
        </span>{" "}
        is supported.
      </p>
      <form className="w-full max-w-sm">
        <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
          <img src={msg} alt="msg-icon" />
          <input
            type="text"
            placeholder="Email Address/Phone number"
            className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2 relative">
          <img src={lock} alt="lock-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 focus:outline-none"
          >
            <img
              src={showPassword ? eyeOpen : eyeSlash}
              alt="toggle password visibility"
            />
          </button>
        </div>
        <div className="flex justify-end mb-4">
          <a href="/auth/forgot-password" className="text-sm text-secondary hover:underline">
            Forgot Password?
          </a>
        </div>
        <button 
          className="w-full rounded-2xl bg-primary text-white py-3 font-bold hover:bg-opacity-90"
          onClick={handleLogin}
          disabled={isSigningIn}
        >
          {isSigningIn ? "Signing in..." : "Sign in"}
        </button>

        <p className="mt-4 text-center text-sm text-gray-600">
          New here? {" "}
          <Link to="/auth/signup" className="font-bold text-secondary hover:underline">
            Join the winning team today!
          </Link>
        </p>

        <div className="w-full flex items-center gap-2 relative top-6">
          <div className="flex-1 border-t border-accent"></div>
          <p className="text-accent font-semibold text-base mx-4">OR</p>
          <div className="flex-1 border-t border-accent"></div>
        </div>

        <button 
          className="w-full mt-10 inline-flex justify-center gap-4 rounded-2xl bg-white text-gray-600 border border-accent py-3 hover:bg-opacity-90"
          onClick={handleGoogleLogin}
        >
          <span>
            <img src={google} alt="google" />
          </span>
          <span>Log in with Google</span>
        </button>

        <button 
          className="w-full mt-4 inline-flex justify-center gap-4 rounded-2xl bg-black text-white border border-accent py-3 hover:bg-opacity-90"
          onClick={handleAppleLogin}
        >
          <span>
            <FaApple className="w-6 h-6" />
          </span>
          <span>Log in with Apple</span>
        </button>
      </form>
    </AuthLayout>
  );
};

export default Signin;
